import React, { useMemo } from 'react';
import { computeRects, deserializeTree } from './paneTreeModel';

const W = 40;
const H = 26;

/**
 * A layout's shape as a tiny SVG, so a saved layout is recognised by its
 * shape. `tree` is a live tree (leaf.pane ids) or a saved one (leaf.slot
 * indices, `saved`); `colors` maps a leaf (pane id or slot index) to a
 * lettermark colour for agent slots.
 */
export default function LayoutThumbnail({ tree, saved = false, colors = {}, width = W, height = H }) {
  const rects = useMemo(() => {
    const live = saved ? deserializeTree(tree, (i) => `slot:${i}`) : tree;
    return live ? computeRects(live, W, H, 1.5).panes : {};
  }, [tree, saved]);
  return (
    <svg className="term-thumb" width={width} height={height} viewBox={`0 0 ${W} ${H}`} aria-hidden focusable="false">
      {Object.entries(rects).map(([id, r]) => {
        const key = saved ? Number(id.slice(5)) : id;
        const color = colors[key];
        return (
          <rect
            key={id}
            x={r.x + 0.5}
            y={r.y + 0.5}
            width={Math.max(0, r.w - 1)}
            height={Math.max(0, r.h - 1)}
            rx={1.5}
            className={color ? 'term-thumb-cell term-thumb-cell--agent' : 'term-thumb-cell'}
            style={color ? { fill: color } : undefined}
          />
        );
      })}
    </svg>
  );
}
